export default "__VITE_ASSET__B5Pfr_48__"